import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";
import { IIPRestriction } from "./_types";

async function createIPRestriction(
  data: IIPRestriction
): Promise<BaseResponse<null>> {
  try {
    return (await axiosInstance.post("/IPRestriction/Add", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useCreateIPRestriction() {
  return useMutation<BaseResponse<null>, Error, IIPRestriction>(
    (variables) => createIPRestriction(variables)
  );
}
